import React, { Component, createContext, useEffect, useState } from "react";
// import MyContext from "./MyContext";
export const MyContext = createContext();
const MyProvider = ({ children }) => {
  const initialCartState = JSON.parse(localStorage.getItem("cart")) || [];
  const [state, setState] = useState("dadsdsd");
  const [cart, setCart] = useState(initialCartState);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [doctorsDetails, setDoctorsDetails] = useState({});

  const [totalAmount, setTotalAmount] = useState(0);

  // Update local storage whenever cart state changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
    // Recalculate total amount
    const newTotalAmount = cart.reduce(
      (acc, item) =>
        parseFloat(acc) + parseFloat(item.opd_amount) * item.quantity,
      0
    );
    setTotalAmount(newTotalAmount);
    localStorage.setItem("totalAmount", JSON.stringify(newTotalAmount));

    const newTotalQuantity = cart.reduce((acc, item) => acc + item.quantity, 0);
    setTotalQuantity(newTotalQuantity);
    localStorage.setItem("totalQuantity", newTotalQuantity);
  }, [cart]);

  const addToCart = (item, type) => {
    // Check if the item is already in the cart

    const isItemInCart = cart.some(
      (cartItem) => cartItem.id === item.id && cartItem.type === type
    );

    if (isItemInCart) {
      // If the item is already in the cart, remove it
      setCart((prevCart) =>
        prevCart.filter((cartItem) => cartItem.id !== item.id)
      );
    } else {
      // If the item is not in the cart, add it
      setCart(
        (prevCart) => [...prevCart, { ...item, quantity: 1, type: type }],
        () => {
          // Callback function after the state has been updated
          // Update local storage
          localStorage.setItem("cart", JSON.stringify(cart));
        }
      );
    }
  };

  const removeItemFromCart = (itemId, type) => {
    const isItemInCart = cart.some((cartItem) => cartItem.id === itemId);
    if (isItemInCart) {
      // If the item is already in the cart, remove it
      setCart((prevCart) =>
        prevCart.filter((cartItem) => cartItem.id !== itemId)
      );
    }
  };
  const removeFromCart = (itemId, type) => {
    setCart([]);
  };

  const increaseQuantity = (itemId) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === itemId ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decreaseQuantity = (itemId) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === itemId
          ? { ...item, quantity: Math.max(1, item.quantity - 1) }
          : item
      )
    );
  };
  const isInCart = (itemId) => {
    const isInCart = cart.find((item) => item.id === itemId);
    return isInCart;
  };

  const DoctorData = (details) => {
    setDoctorsDetails(details);
  };

  const value = {
    state,
    setState,
    cart,
    addToCart,
    removeFromCart,
    increaseQuantity,
    decreaseQuantity,
    totalQuantity,
    setTotalQuantity,
    totalAmount,
    setTotalAmount,
    doctorsDetails,
    DoctorData,
    isInCart,
    removeItemFromCart,
  };

  return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
};

export default MyProvider;



// WEBPACK FOOTER //
// ./src/component/MyProvider.js